import UserService from "@/services/bytepro/user.service";

export const userApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    getUsers({ commit }) {
      return UserService.getUsers().then(
        (resp) => {
          commit("dummy", "UserService.getUsers - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "UserService.getUsers - error");
          return Promise.reject(error.response);
        }
      );
    },
    getUser({ commit }, userId) {
      return UserService.getUser(userId).then(
        (resp) => {
          commit("dummy", "UserService.getUser - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "UserService.getUser - error");
          return Promise.reject(error.response);
        }
      );
    },
    getUsersByOrganizationId({ commit }, organizationId) {
      return UserService.getUsersByOrganizationId(organizationId).then(
        (resp) => {
          commit("dummy", "UserService.getUsers - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "UserService.getUsers - error");
          return Promise.reject(error.response);
        }
      );
    },
    createUser({ commit }, user) {
      return UserService.createUser(user).then(
        (resp) => {
          commit("dummy", "UserService.createUser - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "UserService.createUser - error");
          return Promise.reject(error.response);
        }
      );
    },
    updateUser({ commit }, { userId, updatedUser }) {
      return UserService.updateUser(userId, updatedUser).then(
        (resp) => {
          commit("dummy", "UserService.updateUser - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "UserService.updateUser - error");
          return Promise.reject(error.response);
        }
      );
    },
    getUserByUserName({ commit }, userName) {
      return UserService.getUserByUserName(userName).then(
        (resp) => {
          commit("dummy", "UserService.getUserByUserName - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "UserService.getUserByUserName - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
